import { Component, OnInit } from '@angular/core';
import Slider from '@shared/models/Slider';
import { SlidersService } from '@shared/services/sliders.service';

interface HeroSlide {
  image: string;
  objectPosition: string;
  eyebrowZh: string;
  eyebrowEn: string;
  headlineLineOne: string;
  headlineLineTwo: string;
  tagline: string;
  bodyZh: string;
  bodyEn: string;
  primaryCtaLabel: string;
  primaryCtaHref: string;
  secondaryCtaLabel: string;
  secondaryCtaHref: string;
}

const HERO_COPY = {
  eyebrowZh: $localize`:@@hero.eyebrow.zh:法式手工泡芙 · 香港`,
  eyebrowEn: $localize`:@@hero.eyebrow.en:Artisan Patisserie · Hong Kong`,
  headlineLineOne: $localize`:@@hero.headline.line1:匠心手作`,
  headlineLineTwo: $localize`:@@hero.headline.line2:極致泡芙`,
  tagline: $localize`:@@hero.tagline:Handcrafted with Passion`,
  bodyZh: $localize`:@@hero.body:日式泡芙專賣店\n嚴選新鮮、上等、時令食材 🍓 🥭\n泡芙每日新鮮焗製\n致力為顧客帶來無窮滋味享受！`,
  bodyEn: '',
  primaryCtaLabel: $localize`:@@hero.cta.primary:立即選購`,
  primaryCtaHrefFallback: '#/products/40',
  secondaryCtaLabel: $localize`:@@hero.cta.secondary:品牌故事`,
  secondaryCtaHref: '#/home-page#about'
};

@Component({
  selector: 'app-hero-slider',
  templateUrl: './hero-slider.component.html',
  styleUrls: ['./hero-slider.component.scss']
})
export class HeroSliderComponent implements OnInit {
  constructor(private slidersService: SlidersService) {}
  slideConfig = {
    fade: true,
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    prevArrow: `<button type="button" class="hero-slider__arrow hero-slider__arrow--prev" aria-label="${$localize`:@@hero.arrow.prev:Previous slide`}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round"><path d="M15 18l-6-6 6-6"/></svg></button>`,
    nextArrow: `<button type="button" class="hero-slider__arrow hero-slider__arrow--next" aria-label="${$localize`:@@hero.arrow.next:Next slide`}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round"><path d="M9 18l6-6-6-6"/></svg></button>`
  };

  slides: HeroSlide[] = [];
  private fallbackSlides: HeroSlide[] = [
    this.buildSlide('assets/image/redesign/choux-hero-banner.jpeg', '50% center', HERO_COPY.primaryCtaHrefFallback)
  ];

  ngOnInit(): void {
    this.slidersService.getAllSlider().subscribe(
      (sliders: Slider[]) => {
        const desktop = (sliders || []).find(s => s.name === 'Homepage Banner Desktop');
        const banners = (desktop?.banners || [])
          .filter(b => b.status === 'ACTIVE')
          .sort((a, b) => (a.seq || 0) - (b.seq || 0));

        this.slides = banners.length > 0
          ? banners.map(b => this.buildSlide(
              (b.domain || '') + (b.path || ''),
              '50% center',
              b.url || HERO_COPY.primaryCtaHrefFallback
            ))
          : this.fallbackSlides;
      },
      () => { this.slides = this.fallbackSlides; }
    );
  }

  private buildSlide(image: string, objectPosition: string, primaryCtaHref: string): HeroSlide {
    return {
      image,
      objectPosition,
      eyebrowZh: HERO_COPY.eyebrowZh,
      eyebrowEn: HERO_COPY.eyebrowEn,
      headlineLineOne: HERO_COPY.headlineLineOne,
      headlineLineTwo: HERO_COPY.headlineLineTwo,
      tagline: HERO_COPY.tagline,
      bodyZh: HERO_COPY.bodyZh,
      bodyEn: HERO_COPY.bodyEn,
      primaryCtaLabel: HERO_COPY.primaryCtaLabel,
      primaryCtaHref,
      secondaryCtaLabel: HERO_COPY.secondaryCtaLabel,
      secondaryCtaHref: HERO_COPY.secondaryCtaHref
    };
  }
}
